import Vue from 'vue'
import Vuex from 'vuex'
import helpers from './helpers'
import api from './api/api'
import proxy from './api/proxy'

Vue.use(Vuex)

const protectWizard = {
  namespaced: true,
  state: {
    alive: false,
    step: 0,
    check: false,
    transaction: {
      created: false,
      id: null,
      key: null
    },
    estimated_quote_price: null
  },
  mutations: {
    TRANSACTION_CREATE (state, values) {
      state.alive = true
      state.step = 0
      state.check = false
      state.estimated_quote_price = {}
      state.transaction = helpers.populate(state.transaction, values)
    },
    ESTIMATE (state, values) {
      // This is a temporary workaround until the backend supplies estimates
      if (values) {
        state.estimated_quote_price = values
      } else {
        state.estimated_quote_price = null
      }
    },
    STEP_UPDATE (state, step) { state.step = step },
    CHECK (state, check) { state.check = check || false },
    DIE (state) { state.alive = false }
  },
  actions: {
    initializeTransaction ({ commit, state }) {
      // create transaction
      return proxy.createTransaction().then((data) => {
        return {
          created: true,
          id: data.transaction_id,
          key: data.transaction_key
        }
      }).then((data) => {
        api.setAuthorization('TransactionKey', data.key)
        commit('TRANSACTION_CREATE', data)
        return data
      })
    }
  }
}

const user = {
  namespaced: true,
  state: {
    id: null,
    email: null,
    name: null,
    needsPassword: false
  },
  mutations: {
    USER_CREATED (state, values) {
      state.id = values.id
      state.email = values.email
      state.name = values.name
    },
    USER_NEEDS_PASSWORD (state, value) {
      state.needsPassword = value
    }
  },
  actions: {
    create ({ commit }, params) {
      // Create a new user and associate it with the transaction
      return proxy.createUser(params).then((user) => {
        commit('USER_CREATED', user)
        commit('USER_NEEDS_PASSWORD', !user.has_password)
        return user
      })
    },
    setPassword ({ state, commit }, params) {
      return api.registerCustomer({
        email: state.email,
        ...params
      }).then(() => {
        commit('USER_NEEDS_PASSWORD', false)
      })
    }
  }
}

export default new Vuex.Store({
  modules: {
    user,
    protectWizard
  }
})
